import React, { useEffect, useState } from 'react';
import AuthLayout from "../layouts/AuthLayout";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setShowPreloader } from '../redux/action';
import AuthModel from '../models/AuthMoldel';
import Swal from 'sweetalert2';
import { FiUser, FiLock, FiMail, FiTag, FiEye, FiEyeOff, FiArrowRight } from 'react-icons/fi';
import { FaTelegram } from 'react-icons/fa';
import { RiBuilding4Line, RiSunLine, RiMoonLine } from 'react-icons/ri';
import './auth-modern.css';

const regiterSchema = Yup.object().shape({
    name: Yup.string()
        .max(255, "Tối đa 255 kí tự")
        .required("Vui lòng nhập họ và tên"),
    password: Yup.string()
        .min(6, "Tối thiểu 6 kí tự")
        .max(255, "Tối đa 255 kí tự")
        .required("Vui lòng nhập mật khẩu"),
    user_name: Yup.string()
        .max(255, "Tối đa 255 kí tự")
        .required("Vui lòng nhập tên đăng nhập"),
    email: Yup.string()
        .email("Email không hợp lệ")
        .required("Vui lòng nhập email")
});

function RegisterPage() {
    const queryParameters = new URLSearchParams(window.location.search);
    const [ref, setRef] = useState(queryParameters.get("ref") ? queryParameters.get("ref") : '');
    const [showPassword, setShowPassword] = useState(false);
    const [themeMode, setThemeMode] = useState(() => {
        try {
            const saved = localStorage.getItem('wus_theme_mode');
            return saved === 'dark' || saved === 'light' ? saved : 'dark';
        } catch (e) {
            return 'dark';
        }
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        document.documentElement.setAttribute('data-theme-mode', themeMode);
        if (document.body) document.body.setAttribute('data-theme-mode', themeMode);
    }, [themeMode]);

    const handleToggleTheme = () => {
        const nextMode = themeMode === 'light' ? 'dark' : 'light';
        try {
            localStorage.setItem('wus_theme_mode', nextMode);
        } catch (e) {}
        document.documentElement.setAttribute('data-theme-mode', nextMode);
        if (document.body) document.body.setAttribute('data-theme-mode', nextMode);
        setThemeMode(nextMode);
    };

    const [form] = useState({
        password: "",
        user_name: "",
        name: "",
        email: "",
        referral_code: ref
    });

    const handleChange = (event) => {
        setRef(event.target.value);
    };

    const handleSubmit = async (values, { setFieldError }) => {
        const submitValues = {
            ...values,
            referral_code: ref || values.referral_code
        };

        dispatch(setShowPreloader(true));
        AuthModel.register(submitValues).then((res) => {
            dispatch(setShowPreloader(false));
            if (res.success) {
                Swal.fire({
                    icon: "success",
                    title: "Đăng ký thành công!",
                    showConfirmButton: false,
                    timer: 2000,
                });
                navigate('/login');
            } else {
                if (res.has_errors) {
                    Object.keys(res.errors).forEach((fieldName) => {
                        setFieldError(fieldName, res.errors[fieldName][0]);
                    });
                }
            }
        }).catch((err) => {
            dispatch(setShowPreloader(false));
            Swal.fire({
                icon: "error",
                title: "Đăng ký thất bại!",
                text: err.message || "Có lỗi xảy ra, vui lòng thử lại",
                showConfirmButton: false,
                timer: 2000,
            });
        });
    };

    return (
        <AuthLayout>
            <div className="auth-modern-wrapper">
                <div className="auth-theme-toggle-wrap">
                    <button
                        type="button"
                        className="wus-theme-toggle-btn"
                        onClick={handleToggleTheme}
                        title={themeMode === 'light' ? 'Chuyển sang Giao diện Tối' : 'Chuyển sang Giao diện Sáng'}
                    >
                        {themeMode === 'light' ? (
                            <>
                                <RiMoonLine size={15} />
                                <span className="wus-theme-toggle-label">Giao diện Tối</span>
                            </>
                        ) : (
                            <>
                                <RiSunLine size={15} />
                                <span className="wus-theme-toggle-label">Giao diện Sáng</span>
                            </>
                        )}
                    </button>
                </div>

                <div className="auth-modern-card register-card">
                    {/* Brand Logo */}
                    <div className="auth-brand-logo">
                        <div
                            className="brand-icon"
                            style={{
                                background: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 55%, #7c3aed 100%)',
                                border: '1px solid rgba(255,255,255,0.22)',
                                boxShadow: '0 4px 12px rgba(79, 70, 229, 0.35)'
                            }}
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2L3 6.5V11.5C3 16.85 6.84 21.74 12 23C17.16 21.74 21 16.85 21 11.5V6.5L12 2Z" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="rgba(255,255,255,0.12)" />
                                <path d="M8 9.5H16M12 9.5V16.5M9.5 13.5L12 16.5L14.5 13.5" stroke="#fde047" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div className="brand-name">
                            Bank<span style={{ color: '#4f46e5', fontWeight: 700 }}>TaAnhTu</span>
                        </div>
                    </div>

                    <div className="auth-form-header">
                        <h2>Đăng ký tài khoản</h2>
                        <p>Khởi tạo tài khoản mới để bắt đầu sử dụng</p>
                    </div>

                    <Formik
                        initialValues={form}
                        validationSchema={regiterSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ errors, touched }) => (
                            <Form>
                                <div className="row g-2">
                                    <div className="col-md-6">
                                        <div className="auth-input-group">
                                            <label className="auth-input-label" htmlFor="name">Họ và tên</label>
                                            <div className="auth-input-wrapper">
                                                <FiUser className="auth-input-icon" />
                                                <Field 
                                                    type="text" 
                                                    name="name" 
                                                    placeholder="Nguyễn Văn A" 
                                                    className="auth-input-control" 
                                                    autoComplete="name"
                                                />
                                            </div>
                                            {errors.name && touched.name && (
                                                <div className="auth-error-text">{errors.name}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="auth-input-group">
                                            <label className="auth-input-label" htmlFor="user_name">Tên đăng nhập</label>
                                            <div className="auth-input-wrapper">
                                                <FiUser className="auth-input-icon" />
                                                <Field 
                                                    type="text" 
                                                    name="user_name" 
                                                    placeholder="username123" 
                                                    className="auth-input-control" 
                                                    autoComplete="username"
                                                />
                                            </div>
                                            {errors.user_name && touched.user_name && (
                                                <div className="auth-error-text">{errors.user_name}</div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="auth-input-group">
                                    <label className="auth-input-label" htmlFor="email">Email</label>
                                    <div className="auth-input-wrapper">
                                        <FiMail className="auth-input-icon" />
                                        <Field 
                                            type="email" 
                                            name="email" 
                                            placeholder="example@email.com" 
                                            className="auth-input-control" 
                                            autoComplete="email"
                                        />
                                    </div>
                                    {errors.email && touched.email && (
                                        <div className="auth-error-text">{errors.email}</div>
                                    )}
                                </div>

                                <div className="auth-input-group">
                                    <label className="auth-input-label" htmlFor="password">Mật khẩu</label>
                                    <div className="auth-input-wrapper">
                                        <FiLock className="auth-input-icon" />
                                        <Field 
                                            type={showPassword ? "text" : "password"} 
                                            name="password" 
                                            placeholder="Tối thiểu 6 ký tự" 
                                            className="auth-input-control" 
                                            autoComplete="new-password"
                                        />
                                        <button 
                                            type="button" 
                                            className="auth-password-toggle"
                                            onClick={() => setShowPassword(!showPassword)}
                                            tabIndex="-1"
                                            title={showPassword ? "Ẩn mật khẩu" : "Hiện mật khẩu"}
                                        >
                                            {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                                        </button>
                                    </div>
                                    {errors.password && touched.password && (
                                        <div className="auth-error-text">{errors.password}</div>
                                    )}
                                </div>

                                <div className="auth-input-group">
                                    <label className="auth-input-label" htmlFor="referral_code">
                                        Mã giới thiệu <span style={{ color: "var(--wus-text-subtle)", fontWeight: 400 }}>(tùy chọn)</span>
                                    </label>
                                    <div className="auth-input-wrapper">
                                        <FiTag className="auth-input-icon" />
                                        <Field 
                                            type="text" 
                                            name="referral_code" 
                                            value={ref} 
                                            onChange={handleChange} 
                                            placeholder="Nhập mã nếu có" 
                                            className="auth-input-control" 
                                        />
                                    </div>
                                    {errors.referral_code && touched.referral_code && (
                                        <div className="auth-error-text">{errors.referral_code}</div>
                                    )}
                                </div>

                                <button type="submit" className="auth-btn-primary">
                                    <span>Tạo Tài Khoản</span>
                                    <FiArrowRight size={16} />
                                </button>

                                <div className="auth-switch-link-wrapper">
                                    Đã có tài khoản?
                                    <Link to="/login" className="auth-switch-link">Đăng nhập</Link>
                                </div>

                                <div className="auth-footer-support">
                                    <a 
                                        href="https://t.me/okbillcave" 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="auth-tele-link"
                                        title="Liên hệ hỗ trợ Admin qua Telegram"
                                    >
                                        <span className="auth-tele-icon"><FaTelegram size={16} /></span>
                                        <span>Hỗ trợ Telegram</span>
                                    </a>
                                    <span className="auth-author-text">By: JameBond007</span>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </AuthLayout>
    );
}

export default RegisterPage;
